module.exports = __webpack_public_path__ + "static/media/laptop.1029454d.svg";